import PrivateRoute from "./components/authentication/PrivateRouteComponent";
import PublicRoute from "./components/authentication/PublicRouteComponent";
import { Switch } from "react-router-dom";
import SignIn from "./fetaures/authentication/SignIn";
import SignUp from "./fetaures/authentication/SignUp";
import Logout from "./fetaures/authentication/Logout";
import Dashboard from "./fetaures/dashboard";
import LandingPage from "./fetaures/landing";
import ManageTokens from "./fetaures/tokens";
import Invoices from "./fetaures/invoices/Invoices";
import SubscriptionManager from "fetaures/subscription/SubscriptionManager";
import Users from "fetaures/admin/users";
import Products from "fetaures/admin/products";
import ContactSales from "fetaures/admin/contact-sales";
import { connect } from "react-redux";
import { checkIfUserIsLoggedIn } from "shared/utility/AuthUtility";
import Docs from "fetaures/docs";
import { RootState } from "store/store";
import * as path from "shared/constants/RoutePathConstants";

type Props = {
  isUserLoggedIn: boolean;
};

export function Main(props: Props) {
  const { isUserLoggedIn } = props;

  return (
    <Switch>
      <PublicRoute
        exact
        path={path.HOME}
        component={LandingPage}
        isUserLoggedIn={isUserLoggedIn}
        restricted={true}
      />
      <PublicRoute
        exact
        path={path.SIGN_UP}
        component={SignUp}
        restricted={true}
        isUserLoggedIn={isUserLoggedIn}
      />
      <PublicRoute
        exact
        path={path.SIGN_IN}
        component={SignIn}
        restricted={true}
        isUserLoggedIn={isUserLoggedIn}
      />
      <PrivateRoute
        exact
        path={path.LOG_OUT}
        component={Logout}
        isUserLoggedIn={isUserLoggedIn}
      />
      <PrivateRoute
        path={path.DASHBOARD}
        isUserLoggedIn={isUserLoggedIn}
        component={Dashboard}
      />
      <PrivateRoute
        path={path.GET_STARTED}
        isUserLoggedIn={isUserLoggedIn}
        component={Docs}
      />
      <PrivateRoute
        path={path.SUBSCRIPTION}
        isUserLoggedIn={isUserLoggedIn}
        component={SubscriptionManager}
      />
      <PrivateRoute
        path={path.TOKENS}
        isUserLoggedIn={isUserLoggedIn}
        component={ManageTokens}
      />
      <PrivateRoute
        path={path.INVOICES}
        isUserLoggedIn={isUserLoggedIn}
        component={Invoices}
      />

      <PrivateRoute
        isAdminRoute={true}
        exact
        path={path.ADMIN_USERS}
        component={Users}
        isUserLoggedIn={isUserLoggedIn}
      />
      <PrivateRoute
        isAdminRoute={true}
        exact
        path={path.ADMIN_PRODUCTS}
        component={Products}
        isUserLoggedIn={isUserLoggedIn}
      />
      <PrivateRoute
        isAdminRoute={true}
        exact
        path={path.ADMIN_CONTACT_SALES}
        component={ContactSales}
        isUserLoggedIn={isUserLoggedIn}
      />

    </Switch>
  );
}

const mapStateToProps = (state: RootState) => {
  return {
    isUserLoggedIn: checkIfUserIsLoggedIn(),
  };
};

export default connect(mapStateToProps)(Main);
